"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlowNode = void 0;
const _1 = require(".");
/**
 * Base class for all FlowNodes.
 * These include Events, Gateways and Activities.
 */
class FlowNode extends _1.BaseElement {
    constructor() {
        super(...arguments);
        /**
         * A list of all incoming sequence flow IDs.
         */
        this.incoming = [];
        /**
         * A list of all outgoing sequence flow IDs.
         */
        this.outgoing = [];
        /**
         * A list of all DataInputAssociations.
         * DataInputAssociations point to a DataStore or DataSource that the FlowNode requires data from.
         */
        this.dataInputAssociations = [];
        /**
         * A list of all DataOutputAssociations.
         * DataOutputAssociations point to a DataStore or DataSource that the FlowNode will write to after finishing
         */
        this.dataOutputAssociations = [];
    }
}
exports.FlowNode = FlowNode;
//# sourceMappingURL=FlowNode.js.map